import { Mapper } from "../../../../core/base";
import { GridHeaderWebEntity } from "./grid-header-web-entity";
import { GridHeader } from "../../../../core/domain";

export class GridHeaderWebRepositoryMapper extends Mapper<GridHeaderWebEntity, GridHeader> {
  mapFrom(param: GridHeaderWebEntity): GridHeader {
    return {
      id: param.id,
      displayName: param.displayName,
      schemaName: param.schemaName,
      dataType: param.dataType,
      isShown: param.isShown,
      isFilterable: param.isFilterable,
      isSortable: param.isSortable,
      displayOrder: param.displayOrder,
      entityTypeId: param.entityTypeId,
      entityTypeName: param.entityTypeName,
      readOnly: param.readOnly
    };
  }

  mapTo(param: GridHeader): GridHeaderWebEntity {
    return {
      id: param.id,
      displayName: param.displayName,
      schemaName: param.schemaName,
      dataType: param.dataType,
      isShown: param.isShown,
      isFilterable: param.isFilterable,
      isSortable: param.isSortable,
      displayOrder: param.displayOrder,
      entityTypeId: param.entityTypeId,
      entityTypeName: param.entityTypeName,
      readOnly: param.readOnly
    };
  }

}
